import React, { useContext } from 'react';
import { AuthContext } from '@/App';
import TeamSDS from '@/components/team/TeamSDS';

// Operations Hub entry for the SAME shared Safety Data Sheet library used by TEAM
// Employee Resources. No second library — reuses the TeamSDS component and the
// /api/team/sds endpoints. Authorized Operations personnel get full management
// (upload / replace / update / archive) via the backend capability check.
const OpsSafetyDataSheets = () => {
  const { token } = useContext(AuthContext);
  return (
    <div data-testid="ops-sds">
      <TeamSDS lang="en" token={token} />
    </div>
  );
};

export default OpsSafetyDataSheets;
